const state = {
    // default language
    utm: null,
    ref: null,
    yandexClientId: null,
}

const getters = {
    StateUtm: (state) => state.utm,
    StateRef: (state) => state.ref,
    StateYandexClientId: (state) => state.yandexClientId,
}

const actions = {
    async SetUtm({ commit }, obj) {
        try {
            await commit("setUtm", obj)
        } catch { }
        return true
    },
    async SetRef({ commit }, ref) {
        try {
            await commit("setRef", ref)
        } catch { }
        return true
    },
    async SetYandexClientId({ commit }, id) {
        try {
            await commit("setYandexClientId", id)
        } catch { }
        return true
    }
}

const mutations = {
    setUtm(state, obj) {
        state.utm = obj
    },
    setRef(state, ref) {
        state.ref = ref
    },
    setYandexClientId(state, id) {
        state.yandexClientId = id
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}